import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative bg-primary-500 py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="text-background-50 text-[20rem] font-heading font-bold whitespace-nowrap select-none leading-none">
          GTBUY
        </div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-10 md:mb-14">
          <div className="flex-shrink-0">
            <span className="inline-block px-4 py-1.5 rounded-full border border-background-50/20 text-background-50/70 text-xs font-medium whitespace-nowrap">
              Browse All Categories
            </span>
          </div>
          <div className="flex-1">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
              Shop by Category
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-background-50/5 hover:bg-background-50/10 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.imageAlt}
                  title={`${cat.name} - GTBuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4">
                <p className="text-background-50 text-xs md:text-sm font-medium leading-tight">
                  {cat.name}
                </p>
                <p className="text-background-50/50 text-xs mt-0.5">Shop Now →</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}